import Vue from "vue"

Vue.filter("percentage", function (value, decimals) {
  if (!value) value = 0;
  if (!decimals) decimals = 0;

  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + "%";
});